import { Routes } from '@angular/router';
import { authGuard } from './Modules/Shared/Guards/auth.guard';
import { guestGuard } from './Modules/Shared/Guards/guest.guard';
import { AuthComponent } from './Modules/Auth/auth/auth.component';
import { LoginComponent } from './Modules/Auth/Components/login/login.component';
import { CallbackComponent } from './Modules/Auth/Components/callback/callback.component';
import { AllSetComponent } from './Modules/Setup/Components/Pages/all-set/all-set.component';
import { SetupContainerComponent } from './Modules/Setup/setup-container/setup-container.component';
import { CompanySetupComponent } from './Modules/Setup/Components/Pages/company-setup/company-setup.component';
import { PlanSelectionComponent } from './Modules/Setup/Components/Pages/plan-selection/plan-selection.component';
import { LicencesComponent } from './Modules/Setup/Components/Pages/licences/licences.component';
import { ConnectIntuneComponent } from './Modules/Setup/Components/Pages/connect-intune/connect-intune.component';
import { ReviewComponent } from './Modules/Setup/Components/Pages/review/review.component';

export const routes: Routes = [
  {
    path: '',
    redirectTo: 'setup',
    pathMatch: 'full'
  },
  {
    path: '',
    component: AuthComponent,
    children: [
      {
        path: 'login',
        component: LoginComponent,
        canActivate: [guestGuard]
      },
      {
        path: 'callback',
        component: CallbackComponent
      }
    ]
  },
  {
    path: 'all-set',
    component: AllSetComponent,
    canActivate: [authGuard]
  },
  {
    path: 'setup',
    component: SetupContainerComponent,
    canActivate: [authGuard],
    children: [
      {
        path: 'company-setup',
        component: CompanySetupComponent,
      },
      {
        path: 'plan-selection',
        component: PlanSelectionComponent,
      },
      {
        path: 'licences',
        component: LicencesComponent,
      },
      {
        path: 'connect-intune',
        component: ConnectIntuneComponent,
      },
      {
        path: 'review',
        component: ReviewComponent,
      },
      {
        path: '',
        redirectTo: 'company-setup',
        pathMatch: 'full'
      }
    ]
  },
  {
    path: '**',
    redirectTo: 'setup',
    pathMatch: 'full'
  }
];
